module.exports = __webpack_public_path__ + "static/media/meve.11897249.png";